import 'html/include/js/om/om';
import 'html/include/js/zepto.min';
import 'html/include/js/jquery.unveil';
import 'html/include/js/zepto-anim.min';
import '@html/_common/script_es6';

import {
  byUserInteraction,
  getCookie,
  parameters,
  sendAmplitudeEvent,
  sendDataLayerEvent,
  sendGoogleEvent,
} from '@html/_common/utils';

import Pagination from '@scout/components/pagination/pagination';
import SerpCommon from '@html/serp/common';
import Timer from '@html/_utils/timer';
import SerpBanner from '@html/serp/serp-banner';
import AOSerpBreadcrumbs from '@atomic/organisms/serp/breadcrumbs';
import SerpTours from '@html/serp/tours/script';
import SerpSponsoredCard from '@html/serp/sponsored-card';
import AOSerpEmailSignup from '@atomic/organisms/serp/email-signup';
import LiveChat from '@html/_modules/live-chat';
import SerpContactSection from '@atomic/organisms/serp/contact-section';
import AOTourTravelAgentShareTour from '@atomic/organisms/_common/travel_agent/travel-agent-share-tour-popup';
import AOCommunityBanner from '@atomic/organisms/_common/banners/community/community-banner';

export default function Serp() {
  this.initiate = () => {
    const serpCommon = new SerpCommon();
    const appliedFiltersCookie = getCookie('serp-filters');
    let filtersLoaded = false;

    const common = {
      sendGoogleEvent,
      sendAmplitudeEvent,
      byUserInteraction,
      parameters,
    };
    // eslint-disable-next-line no-unused-vars
    const liveChat = new LiveChat(false, common);

    const sponsoredCard = new SerpSponsoredCard();
    sponsoredCard.initiate();

    const serpBanner = new SerpBanner();
    serpBanner.initiate();

    const pagination = new Pagination('SERP');
    pagination.init();

    const contactSection = new SerpContactSection();
    contactSection.initiate();

    const communityBanner = new AOCommunityBanner();
    communityBanner.initiate();

    if ($('.js-sale-line').length > 0) {
      new Timer($('.js-sale-line .js-ends span'), $('.js-sale-line .js-ends').data('ends')).initiate();
    }

    const emailSignup = new AOSerpEmailSignup();
    emailSignup.initiate();

    const breadcrumbs = new AOSerpBreadcrumbs();
    breadcrumbs.initiate();

    const serpTours = new SerpTours(serpCommon);
    serpTours.initiate();

    $('.js-am-serp-month-links__list-item-button').on('click', (event) => {
      event.preventDefault();
      window.location.href = event.currentTarget.getAttribute('data-link').replaceAll('@', '/');
    });

    this.loadFilters = (clickedElem = null) => {
      filtersLoaded = true;
      import(/* webpackChunkName: "serpFilters" */'@html/serp/filters/script').then((module) => {
        const SerpFilters = module.default;
        const serpFilters = new SerpFilters(serpCommon, serpTours);
        if (!clickedElem) {
          serpFilters.initiate();
        } else {
          serpFilters.initiate(() => {
            $('.js-ao-serp-filter-bar__list').find(clickedElem).trigger('click');
          });
        }
      });
    };

    const hasCookiePaxData = document.cookie.split('; ').some((row) => row.startsWith('pax_number_of_adults=') || row.startsWith('pax_number_of_children=') || row.startsWith('pax_month_year='));

    if (
      (parameters.serp_applied_filters === 1 && !!appliedFiltersCookie)
      || (window.location.hash.length > 1 && window.location.hash !== '#_')
      || hasCookiePaxData
    ) {
      this.loadFilters();
    } else if ($(window).width() < 1024) {
      $('.js-ao-serp-filter-bar__list-item--dates').on('click', () => {
        if (!filtersLoaded) {
          this.loadFilters('.js-ao-serp-filter-bar__list-item--dates');
        }
      });
      $('.js-ao-serp-filter-bar__list-item--destinations').on('click', () => {
        if (!filtersLoaded) {
          this.loadFilters('.js-ao-serp-filter-bar__list-item--destinations');
        }
      });
      $('.js-ao-serp-filter-bar__list-item--more').on('click', () => {
        if (!filtersLoaded) {
          this.loadFilters('.js-ao-serp-filter-bar__list-item--more');
        }
      });
    } else {
      byUserInteraction('init-serp-filters', this.loadFilters);
    }

    if (parameters.is_mobile && window.location.href.includes('/srp/')) {
      byUserInteraction('app-redirect-popup', () => {
        import(/* webpackChunkName: "appRedirectPlugin" */'app/application/views/app-redirect-popup/script').then((module) => {
          const AppRedirectPopup = module.default;
          const appRedirectPopup = new AppRedirectPopup();

          appRedirectPopup.initialize();
        });
      });
    }

    if (window.ecommerce) {
      byUserInteraction('initiate-serp-ecommerce', () => {
        sendDataLayerEvent({
          event: 'ecommerceEvent',
          ecommerce: window.ecommerce,
        });
      });
    }

    this.paginationMobileTracking();

    if ($(AOTourTravelAgentShareTour.getTriggerSelector()).length) {
      const pageId = $('main').attr('data-page');
      const shareCoBrandedTDP = new AOTourTravelAgentShareTour({ serpId: pageId });
      shareCoBrandedTDP.init();
    }
  };

  this.paginationMobileTracking = () => {
    $('body').on('click', '.js-pagination-mobile-button--next, .js-pagination-mobile-button--prev', (e) => {
      const isPrevious = $(e.currentTarget).hasClass('js-pagination-mobile-button--prev');
      const label = isPrevious ? 'Prev' : 'Next';

      sendGoogleEvent(
        'Serp',
        `Pagination ${label} click`,
        label,
      );
    });
  };
}
